import React, { useEffect, useState } from 'react';
import FalconComponentCard from 'components/common/FalconComponentCard';
import IconButton from 'components/common/IconButton';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { toast } from 'react-toastify';
import firebase from './../../../firebase';
import { Badge, Col } from 'react-bootstrap';
import { makeCsv, getTableDataForExport, getColKeyArrayObject } from 'state/actions/users';
import { API_URL } from 'constants'; 
import { useNavigate } from "react-router-dom"; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logoIcon from 'assets/img/logoIcon.png';

const Villas = () => {
  const navigate = useNavigate(); // Initialiser useNavigate
  const [isadmin, setAdmin] = React.useState(false)
  const [l, setL] = React.useState(true);
  const [data, setData] = React.useState([]);
  const [colexport, setColExport] = React.useState([]);
  const [showBookerMenu, setShowBookerMenu] = useState(null);
  const [users, setUsers] = useState([]);


  const loadUsers = async () => {
    const usersSnapshot = await firebase.firestore().collection('users').get();
    const usersData = [];
    usersSnapshot.forEach(doc => {
      const userData = doc.data();
      if (userData.delete != true && userData.type === 'admin') { 
        usersData.push({ id: doc.id, ...userData });
      }
    });
    setUsers(usersData);
  };

 

  const getEn = (text, cb) => {
    fetch(`${API_URL}traduction`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text: text }),
    })
      .then((res) => res.json())
      .then((data) => {
        cb(data?.en || '')
      })
  }

  const prep = (d, cb) => {

    getEn(d.description, (en) => {
      let ject = {
        by: d,
        _create_At: new Date(),
        _update_At: new Date(),
        adresse: d.address,
        chauffage_info: "",
        city: d.city,
        country: d.country,
        currency_code: d.currency_code,
        contructIn: "",
        description: d.description,
        description_en: en,
        detailpiece: `Le bien est constituée de ${d?.rooms[0]?.bedrooms || 1} chambres, ${d?.rooms[0]?.bathrooms || 1} salles de bains,`,
        distance: "",
        eauchaude: "",
        eauxusees: "",
        equipments: [

        ],
        etage: "",
        etat: "",
        exposition: "",
        fhsId: null,
        files: [],
        gallery: d.rooms[0]?.images || [],
        group: null,
        _id: d.id,
        isfavorite: false,
        localisation: {
          lat: d.latitude,
          long: d.longitude,
        },
        m2: "",
        m2habitable: "",
        maxGuest: `${d.rooms[0]?.max_people || 1}`,
        nameHouse: d?.name,
        nbBath: `${d.rooms[0]?.bathrooms}`,
        nbRooms: `${d.rooms[0]?.bedrooms}`,
        newInfofile: null,
        ownerId: null,
        prices: [
          {
            price: "2000",
            per: {
              label: "Semaine",
              value: "week"
            },
            months: [
              { label: "Janvier", value: 1 },
              { value: 2, label: "Février" },
              { label: "Mars", value: 3 }
            ],
            title: "saison 1"
          }
        ],
        prix: `${d.max_price}`,
        quartier: `${d.state}`,
        services: [

        ],
        show_parter: true,
        standing: "",
        style: "",
        type: null,
        typrr: "",
        vue: "",
        zipcode: `${d.zip}`
      }
      cb(ject)
    });



  }
  const createPropertie = (p) => {
    try {
      firebase.firestore().collection('properties').add(p).then((doc) => {
        // console.log("Document successfully written!");
        toast.success("Propriété créer avec succès" + doc.id);
        // navigate('/villa/edit/'+doc.id)
      }).catch((error) => {
        setL(false);
        var errorMessage = error.message;
        toast.error(errorMessage);
      })
    } catch (error) {
      setL(false);
      var errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  const [bookersState, setBookersState] = useState({});

  const loadVilla = (admin) => {
    setL(true);
    if (admin) {
      firebase.firestore().collection('properties').get().then((snap) => {
        let s = [];
        let initialBookers = {};
        snap.forEach((d) => {
          var l = d.data();
          l.id = d.id;
          if (l?.delete) {
            // supprimer donc ne pas affiché
          } else {
            l.prix = `${l.priceStart?.price} € / ${l.priceStart?.per?.label}`;
            l.typrr = l?.type?.label;
            s.push(l)
            initialBookers[l.id] = l.bookerId || null;
          }

        })
        setData(s);
        setBookersState(initialBookers);
        setColExport(getColKeyArrayObject(s));
        setL(false);
      }).catch((error) => {
        setL(false);
        var errorMessage = error.message;
        toast.error(errorMessage);
      })
    } else {
      firebase.firestore().collection('properties')
        .where('show_parter', '==', true)
        .get().then((snap) => {
          let s = [];
          snap.forEach((d) => {
            var l = d.data();
            l.id = d.id;
            if (l?.delete) {
              // supprimer donc ne pas affiché
            } else {
              l.prix = `${l.priceStart?.price} € / ${l.priceStart?.per?.label}`;
              l.typrr = l?.type?.label;
              s.push(l)
            }

          })
          setData(s);
          setColExport(getColKeyArrayObject(s));
          setL(false);
        }).catch((error) => {
          setL(false);
          var errorMessage = error.message;
          toast.error(errorMessage);
        })
    }


  }

  const delIt = async (id) => {
    setL(true);
    try {
      firebase.firestore().collection('properties').doc(id).update({ delete: true }).then((snap) => {
        loadVilla(isadmin);
        toast.success("Suppression effectué");
      })
    } catch (err) {
      setL(false);
      // eslint-disable-next-line no-console
      console.log(err);
      toast.error("Une erreur s'est produite");
    }
  };
  const del = (id) => {
    if (confirm(`Êtes vous certain de vouloir supprimer la villa?`)) {
      delIt(id);
    }
  }
  const [duplicationL, setDuplicationL] = useState(false);

  // Fonction pour dupliquer une villa
  const duplicateVilla = async (property) => {
    if (duplicationL) return;
    // demander si on confirme la duplication avec une alert de confirmation 
    const isConfirmed = window.confirm("Voulez-vous vraiment dupliquer cette villa ?");

    if (!isConfirmed) {
      return; // Si l'utilisateur annule, on arrête ici
    }

    
    
    setDuplicationL(true);
    toast.warning('Duplication en cours... ')
    try {
      let p = property
      p.copyby = property.id
      delete p.id;
      p._create_At = new Date();
      p._update_At = new Date();
      delete p.sync;
      delete p.wp_id;
      // Récupérer les données de la villa à partir de Firestore
      // const propertyRef = doc(db, "properties", propertyId);
      // const propertySnap = await getDoc(propertyRef);

      // if (propertySnap.exists()) {
      //   const propertyData = propertySnap.data();

      // Préparer les nouvelles données pour la duplication
      const newPropertyData = {
        ...p,
        nameHouse: `${p.nameHouse} (copie)`, // Ajouter "copie" au nom  
      };

      // Ajouter un nouveau document dans Firestore
      firebase.firestore().collection('properties').add(newPropertyData).then(newDocRef => {
        // Récupérer l'ID du nouveau document
        const newDocId = newDocRef.id;

        console.log("Nouvelle villa créée avec l'ID :", newDocId); 
        // (Optionnel) Notifier ou rafraîchir la liste
        toast.success('Villa dupliquée avec succès, redirection...');
        navigate(`/villa/edit/${newDocId}`);
      }).catch((error) => {
        console.error("Erreur lors de la duplication :", error);
        toast.error('Erreur lors de la duplication');
      }).finally(() => {
        setDuplicationL(false);
      })
    } catch (error) {
      console.error("Erreur lors de la duplication :", error);
      toast.error('Erreur lors de la duplication');
      setDuplicationL(false);
    }
  };

  const columns = [
    {
      accessor: 'nameHouse',
      Header: 'Titre',
      headerProps: { className: 'text-900' },
      Cell: ({ row }) => (
        <div style={{textAlign: 'start'}}>

          {row?.original?.gallery?.length > 0 && <img src={row?.original?.gallery?.length > 0 && row?.original?.gallery[0]} width={70} />}
          <span style={{ marginLeft: 20 }}>{row?.original?.nameHouse}</span>
        </div>
      )
    },
    {
      accessor: 'adresse',
      Header: 'Adresse',
      headerProps: { className: 'text-900', },
      Cell: ({ row }) => (
        <p style={{ maxWidth: 150, overflow: "hidden" }}>
          <span  >{row?.original?.adresse}</span><br />
          <span  >{row?.original?.city}</span><br />
          <span  >{row?.original?.zipcode}</span>
        </p>
      )
    },
    {
      accessor: 'prix',
      Header: 'Prix',
      headerProps: { className: 'text-900' },
      Cell: ({ row }) => {
        return <p>{row?.original?.prices?.map((f, i) => {
          if (i === 0) return <span>{f?.price} €</span>
        })}</p>
      }
    },
    {
      accessor: 'maxGuest',
      Header: 'Max Guest',
      headerProps: { className: 'text-900' },
    },
    {
      accessor: 'typrr',
      Header: 'Type',
      headerProps: { className: 'text-900' },
    },
    {
      accessor: 'action',
      Header: 'Action',
      headerProps: { className: 'text-900' },
      Cell: rowData => {
        const { id, isfavorite = false, nameHouse, fhsId } = rowData.row.original
        const [isFav, setIsFavorite] = useState(isfavorite)
        const [ll, setLL] = useState(false) 
        const currentBooker = bookersState[id];

        const updateBooker = async (userId) => {
          try {
            await firebase.firestore().collection('properties').doc(id).update({
              bookerId: userId
            });
            setBookersState(prev => ({
              ...prev,
              [id]: userId
            }));
            setShowBookerMenu(null);
          } catch (error) {
            console.error("Erreur lors de la mise à jour du booker:", error);
            toast.error("Erreur lors de la mise à jour du booker");
          }
        };

 

        const favorite = () => {
          if (ll) {
            return
          }
          setLL(true)
          let nfav = !isFav;
          firebase.firestore().collection('properties').doc(id).update({ isfavorite: nfav }).then(() => {
            setLL(false)
            setIsFavorite(nfav) 
          }).catch(() => {
            setLL(false) 
          })

        }

        return (<div style={{textAlign: 'end'}}>

          {rowData.row?.original?.wp_id && rowData.row?.original?.sync === true && (<Badge style={{marginRight: 10}}>WP</Badge> )}
          
          {/* afficher ici un element me permettant de choisir un booker (c'est une personne qui gère generalement cette villa) on peut le faire avec un avatar vide si bookerId est null et on l'associe a l'utilisateur avec sa photo, si on clique dessus on peut changer avec un menu l'utilisateur booker */}
           
          <div style={{ display: 'inline-block', marginRight: '10px', position: 'relative' }}>
            <IconButton
              variant="falcon-link"
              size="sm"
              className="avatar-button"
              onClick={(e) => {
                e.stopPropagation();
                  setShowBookerMenu(showBookerMenu === id ? null : id);
              }}
            >
              {currentBooker ? (
                <>
                  <img 
                  src={users.find(u => u.id === currentBooker)?.picture_profile || logoIcon} 
                    alt="Booker" 
                    style={{ width: '24px', height: '24px', borderRadius: '50%' }}
                  />
                  <span> {users.find(u => u.id === currentBooker)?.firstName} {users.find(u => u.id === currentBooker)?.lastName}</span>
                 </>
              ) : (
                <FontAwesomeIcon icon="user-circle" />
              )}
            </IconButton>
            
            {showBookerMenu === id && (
              <div 
              ref={(el) => {
                if (el) {
                  el.style.position = 'absolute';
                  el.style.right = '0';
                  if (rowData.row.index < 50) {
                    el.style.top = '100%';
                    el.style.bottom = 'auto';
                  } else {
                    el.style.bottom = '100%';
                    el.style.top = 'auto';
                  }
                }
              }}
              style={{
                backgroundColor: 'white',
                border: '1px solid #ddd',
                borderRadius: '4px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                zIndex: 1000,
                minWidth: '200px'
              }}
              >
                {users.map(user => (
                  <div
                    key={user.id}
                    onClick={ () => {
                      updateBooker(user.id);
                    }}
                    style={{
                      padding: '8px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                  >
                    <img 
                      src={user.picture_profile || logoIcon} 
                      alt={user.firstName} 
                      style={{ width: '24px', height: '24px', borderRadius: '50%' }}
                    />
                    <span>{user.firstName} {user.lastName}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          {isadmin ? (<>
            {
              (fhsId === null || fhsId === undefined || fhsId.length === 0) && (
                <IconButton onClick={() => {
                  // console.log("p", rowData.row.original);
                  toast.success("Redirection");
                  window.location.href = `https://fabiohome-1.web.app/api?api_key=fG7LwR2BzN5q8TdYX6pVQKj3CmAH9Ws4&nameHouse=${nameHouse}&id=${id}&return_url=https://bo-house.software/connect`;
                }}
                  variant="falcon-link"
                  size="sm"
                  icon="link"
                  transform="shrink-3"
                  className='me-2'
                >
                  FHS
                </IconButton>
              )
            }
            <IconButton target="_blank" href={`/v/${id}`}
              variant="falcon-primary"
              size="sm"
              icon="eye"
              transform="shrink-3"
              className='me-2'
            >
              <span className="d-none d-sm-inline-block ms-1"></span>
            </IconButton>
            <IconButton href={`/villa/edit/${id}`}
              variant="falcon-default"
              size="sm"
              icon="edit"
              transform="shrink-3"
              className='me-2'
            >
              <span className="d-none d-sm-inline-block ms-1"></span>
            </IconButton>

            <IconButton
              onClick={() => { duplicateVilla(rowData.row.original) }}

              variant={!duplicationL ? "falcon-primary" : "falcon-warning"}
              size="sm"
              icon="copy"
              transform="shrink-3"
              className='me-2'
            > 
              <span className="d-none d-sm-inline-block ms-1">{duplicationL ? 'Chargement...' : "Copy"}</span>
               
            </IconButton>

            <IconButton
              onClick={favorite}

              variant={isFav ? "falcon-warning" : "falcon-default"}
              size="sm"
              icon="star"
              transform="shrink-3"
              className='me-2'
            >
              <span className="d-none d-sm-inline-block ms-1">{ll && 'Chargement...'}</span>
            </IconButton>

            <IconButton onClick={() => {
              del(id);
            }}
              variant="falcon-danger"
              size="sm"
              icon="trash"
              transform="shrink-3"
              className='me-2'
            >
              <span className="d-none d-sm-inline-block ms-1"></span>
            </IconButton>
          </>) : (
            <IconButton target="_blank" href={`/vl/${id}`}
              variant="falcon-primary"
              size="sm"
              icon="eye"
              transform="shrink-3"
              className='me-2'
            >
              <span className="d-none d-sm-inline-block ms-1"></span>
            </IconButton>
          )}
        </div>
        )
      }
    }
  ];

  const getUser = async (uid, cb) => {
    await firebase.firestore()
      .collection("users")
      .doc(uid)
      .get()
      .then(async (docd) => {
        if (docd.exists) {

          var user = docd.data();
          user.id = docd.id;
          if (user?.delete) {
            cb(null)
          } else {
            cb(user);
          }

        } else {
          cb(null);
        }
      })
      .catch((error) => {
        console.log("error", error);
        cb(null);
      });
  };

  React.useEffect(() => {
    firebase.auth().onAuthStateChanged((u) => {
      if (u) {
        loadUsers();
        //redirection au compte
        getUser(u.uid, (user) => {
          // console.log("user", user); 
          if (user && user?.type === 'admin') {
            setAdmin(true);
            loadVilla(true)
          } else {
            loadVilla(false)
          }
        });
      } else {
        setL(false)
      }
    });
  }, [])


  // const data = [
  //   {
  //     id: '345678',
  //     firstName: 'Anna',
  //     lastName: 'Anna',
  //     email: 'anna@example.com',
  //     phone: "06933322525", 
  //     type:"modérateur"
  //   },
  //   {
  //     id: '345678',
  //     firstName: 'Anna',
  //     lastName: 'Anna',
  //     email: 'anna@example.com',
  //     phone: "06933322525", 
  //     type:"admin"
  //   },
  // ];




  function AdvanceTableExample() {

    if (l) {
      return <p>Chargement...</p>
    }
    return (
      <AdvanceTableWrapper
        columns={columns}
        data={data}
        sortable
        pagination
        perPage={605}
      >
        <Col xs={8} sm="auto" className="ms-auto text-end ps-0 mb-3">
          {isadmin && (
            <div id="orders-actions">
              <IconButton href="/newvilla"
                variant="falcon-default"
                size="sm"
                icon="plus"
                transform="shrink-3"
                className='me-2'
              >
                <span className="d-none d-sm-inline-block ms-1">Nouvelle propriété</span>
              </IconButton>
              
        {/* <IconButton  onClick={async () => {
          const testSendEmailQuestionnaire = firebase.functions().httpsCallable("testSendEmailQuestionnaire")
          await testSendEmailQuestionnaire({ });
                      
        }}
          variant="falcon-default"
          size="sm"
          icon="plus"
          transform="shrink-3"
          className='me-2'
        >
         Envoie questionnaire test
        </IconButton>  */}
          


              {data && data.length > 0 && (
                <IconButton

                  variant="falcon-default"
                  size="sm"
                  icon="file"
                  transform="shrink-3"
                  className='me-2'
                  onClick={() => makeCsv(getTableDataForExport(data, colexport), `villa-bo-house.csv`)}

                >
                  Export des données en CSV
                </IconButton>)}
              <Col xs="auto" sm={6} lg={4}>
                <AdvanceTableSearchBox table />
              </Col>
            </div>
          )}
        </Col>
        <AdvanceTable
          table
          headerClassName="bg-200 text-nowrap align-middle"
          rowClassName="align-middle white-space-nowrap"
          tableProps={{
            bordered: true,
            striped: true,
            className: 'fs--1 mb-0 overflow-hidden'
          }}
        />
        <div className="mt-3">
          <AdvanceTableFooter
            rowCount={data.length}
            table
            rowInfo
            navButtons
            rowsPerPageSelection
          />
        </div>
      </AdvanceTableWrapper>
    );
  }


  return (

    <FalconComponentCard>
      <FalconComponentCard.Header
        title="Propriétés"
        light={false}
        className="border-bottom border-200" noPreview={true}
      />

      
      <FalconComponentCard.Body>
        <AdvanceTableExample />
      </FalconComponentCard.Body>
    </FalconComponentCard>
  );
}

export default Villas;
